import React, { useEffect, useState } from 'react';

//Material
import { Avatar, Box, Menu, MenuItem, Typography } from '@mui/material';
// import { dateFormattingByDate } from '../helpers/date-helpers';
import DefaultAvatar from '../assets/defaultPostImg.jpg';
import ReplyIcon from '@mui/icons-material/Reply';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ApiService from '../helpers/apiHelper';
import { connect, useDispatch, useSelector } from 'react-redux';
import { timeDiff } from '../helpers/date-helpers';
import { useNavigate } from 'react-router-dom';

import { setIsOpenComplainModal, setIsOpenDeleteModal } from '../redux/mainReducer';
import { useSnackbar } from 'notistack';
import { MoreHoriz } from '@mui/icons-material';

function ResponseBlock({
  parrentCommentWriter,
  dataSet,
  index,
  response,
  setter,
  setToDelete,
  setModalText,
  isOnComments,
  setIsResponse,
  setResponseId,
  setResponseNickName,
  setTopComment,
  setIsEdit,

  ...props
}) {
  const [responses, setResponses] = useState([]);
  // eslint-disable-next-line

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const isOpenDeleteModal = useSelector((state) => state.global.isOpenDeleteModal);
  const userData = useSelector((state) => state.global.userData);
  const language = useSelector((state) => state.Intl.locale);
  const blockedUsers = useSelector((state) => state.global.blockedUsers);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const apiResponses = new ApiService('posts/comment/get-responses');
  const apiComment = new ApiService('posts/comment');
  const apiAddLike = new ApiService('posts/comment/like');
  const apiComplaint = new ApiService('posts/comment/complaint-comment');

  // const apiResponses = new ApiService('/comment/get-responses');
  // const apiComment = new ApiService('/comment');
  // const apiAddLike = new ApiService('/comment/like');
  // const apiComplaint = new ApiService('/comment/complaint-comment');

  const sendComplaint = (type, text) => {
    apiComplaint
      .updateDataID(response?.id, {
        complaintType: type,
        complaintDescription: text.length !== 0 ? text : null
      })
      .then((res) => {
        dispatch(setIsOpenComplainModal({ isOpen: false, func: null }));
        enqueueSnackbar('Скаргу надіслано.', { variant: 'success' });
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка.', { variant: 'error' });
      });
  };

  const getResponses = () => {
    apiResponses.getItemById(response.id).then((res) => {
      setResponses([...res.result]);
    });
  };

  const deleteElement = (id) => {
    apiComment.deleteItem(id).then((res) => {
      if (dataSet) {
        dataSet();
      }
      if (setter) {
        setter();
      }
      dispatch(setIsOpenDeleteModal({ ...isOpenDeleteModal, isOpen: false }));
    });
  };
  // eslint-disable-next-line
  useEffect(() => {
    if (response && response?.numberResponses > 0) {
      getResponses();
    }
    // eslint-disable-next-line
  }, [response]);

  return (
    <div
      key={`response${index}`}
      style={{ display: 'flex', flexDirection: 'column', marginTop: '10px', position: 'relative' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'start',
          justifyContent: 'start'
        }}
      >
        <Avatar
          onClick={() => navigate(`/${language}/user-page/${response.userDTO.id}?type=posts`)}
          alt="avatar"
          src={
            response?.userDTO?.encodedMediaDTO
              ? `data:${response?.userDTO?.encodedMediaDTO.contentType};base64, ${response?.userDTO?.encodedMediaDTO.encodedContent}`
              : DefaultAvatar
          }
          sx={{
            width: { xs: 40, sm: 60 },
            height: { xs: 40, sm: 60 },
            // border: '2px solid #E2F2FF',
            mr: 1,
            cursor: 'pointer',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'center'
          }}
        >
          <Typography
            onClick={() => navigate(`/${language}/user-page/${response.userDTO.id}?type=posts`)}
            sx={{
              fontFamily: 'FixelText-Medium',
              fontSize: { xs: '12px', sm: '14px' },

              textAlign: 'left',
              fontWeight: '500',
              cursor: 'pointer',
              color: '#7C7C7C'
            }}
          >
            {`${response?.userDTO?.nickname}`}
            {' • '}
            {timeDiff(response.creationTimeForComment)}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'FixelText-Regular',
              fontWeight: '400',
              fontSize: { xs: '14px', sm: '16px' },
              wordBreak: 'break-word',
              textAlign: 'left'
            }}
            children={response?.text
              .split('\r\n')
              .filter((el) => el.length !== 0)
              .map((string, index) => {
                return (
                  <p key={index} style={{ margin: '0' }}>
                    <Typography
                      onClick={() =>
                        navigate(`/${language}/user-page/${response.userDTO.id}?type=posts`)
                      }
                      component="span"
                      sx={{
                        margin: '0px 5px 0px 0px',
                        fontFamily: 'FixelText-Regular',
                        fontWeight: '400',
                        fontSize: { xs: '14px', sm: '16px' },
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        width: 'fit-content',
                        wordBreak: 'break-word'
                      }}
                      // >{`@${parrentCommentWriter.nickname}`}</span>
                    >{`@${parrentCommentWriter?.nickname}`}</Typography>
                    {string}
                    <br />
                  </p>
                );
              })}
          />
          <div style={{ display: 'flex', marginTop: '8px' }}>
            {response?.idsUsersThatLikesComment.length !== 0 &&
            response?.idsUsersThatLikesComment.includes(userData?.id) ? (
              <FavoriteIcon
                onClick={() =>
                  blockedUsers &&
                  !blockedUsers.find((user) => user.id === response?.userDTO?.id) &&
                  apiAddLike
                    .updateDataQuery({ commentId: response.id, isLikedComment: false })
                    .then((res) => setter())
                }
                sx={{
                  fontSize: { xs: '22px' },
                  color: 'red',
                  cursor: 'pointer'
                }}
              />
            ) : (
              <FavoriteBorderIcon
                onClick={() =>
                  blockedUsers &&
                  !blockedUsers.find((user) => user.id === response?.userDTO?.id) &&
                  apiAddLike
                    .updateDataQuery({ commentId: response.id, isLikedComment: true })
                    .then((res) => setter())
                }
                sx={{
                  fontSize: { xs: '22px' },
                  ':hover': {
                    color: 'red'
                  },
                  cursor: 'pointer'
                }}
              />
            )}
            {response.valueLikes > 0 && (
              <Typography
                sx={{
                  ml: '8px',
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px' },
                  fontWeight: 500
                }}
              >
                {' '}
                {response.valueLikes > 0 && response.valueLikes}
              </Typography>
            )}

            {blockedUsers &&
            !blockedUsers.find((user) => user.id === response?.userDTO?.id) &&
            isOnComments ? (
              <ReplyIcon
                onClick={() => {
                  setIsResponse(true);
                  setResponseId(response?.id);
                  setResponseNickName(response?.userDTO?.nickname);
                }}
                sx={{
                  fontSize: { xs: '22px' },
                  ml: 1,
                  cursor: 'pointer',
                  ':hover': {
                    color: '#60A5DF'
                  }
                }}
              />
            ) : null}
          </div>
        </Box>
      </Box>

      {responses.length !== 0 &&
        responses.map((resp, index) => (
          <ResponseBlock
            response={resp}
            setter={getResponses}
            dataSet={setter}
            parrentCommentWriter={response.userDTO}
            isOnComments={isOnComments}
            setIsResponse={setIsResponse}
            setResponseId={setResponseId}
            setResponseNickName={setResponseNickName}
            setTopComment={setTopComment}
            setIsEdit={setIsEdit}
          />
        ))}
      <Box
        id="positioned-button"
        onClick={(event) => handleClick(event)}
        sx={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: { xs: '24px' },
          height: { xs: '24px' },
          backgroundColor: 'white',
          cursor: 'pointer',
          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
          borderRadius: '50px',
          right: { xs: '0px' },
          top: { xs: '8px' },
          zIndex: 102
        }}
      >
        {' '}
        <MoreHoriz sx={{ cursor: 'pointer', fontSize: '18px' }} />
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="action-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'hidden',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            borderRadius: '4px',
            border: 'none',
            paddingTop: '10px',
            paddingLeft: '20px',
            paddingRight: '20px',
            width: '283px',
            mt: 1
          }
        }}
        autoFocus={false}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {response?.userDTO?.id !== userData?.id && (
          <div>
            <MenuItem
              sx={{
                borderRadius: '4px',
                ':hover': { backgroundColor: '#FFE5E5' },

                fontFamily: 'FixelText-Medium',
                fontWeight: '500',
                color: '#F64D36',
                pl: '12px !important',
                m: '2px 0px !important'
              }}
              onClick={() => {
                dispatch(setIsOpenComplainModal({ isOpen: true, func: sendComplaint }));

                handleClose();
              }}
            >
              Поскаржитись
            </MenuItem>
          </div>
        )}
        {response?.userDTO?.id === userData?.id && (
          <div>
            {isOnComments ? (
              <MenuItem
                sx={{
                  borderRadius: '4px',
                  '&.MuiMenuItem-root:hover': { backgroundColor: '#E2F2FF' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  pl: '12px !important',
                  m: '2px 0px !important'
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  setTopComment(response?.text);
                  setIsEdit(true);
                  setResponseId(response?.id);
                  handleClose();
                }}
              >
                Редагувати
              </MenuItem>
            ) : null}

            <MenuItem
              sx={{
                borderRadius: '4px',
                ':hover': { backgroundColor: '#FFE5E5' },

                fontFamily: 'FixelText-Medium',
                fontWeight: '500',
                color: '#F64D36',
                pl: '12px !important',
                m: '2px 0px !important'
              }}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                dispatch(
                  setIsOpenDeleteModal({
                    isOpen: true,
                    text: 'цю відповідь?',
                    func: deleteElement,
                    id: response.id
                  })
                );
                handleClose();
              }}
            >
              Видалити відповідь
            </MenuItem>
          </div>
        )}
      </Menu>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    blockedUsers: state.global.blockedUsers
  };
};
export default connect(mapStateToProps)(ResponseBlock);
